import {
    HTTP_INTERCEPTORS,
    provideHttpClient,
    withInterceptorsFromDi,
} from '@angular/common/http';
import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { SessionRefreshInterceptor } from './session-refresh.interceptor';

export function provideApplicationHttpClient(): EnvironmentProviders {
    return makeEnvironmentProviders([
        provideHttpClient(withInterceptorsFromDi()),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: SessionRefreshInterceptor,
            multi: true,
        },
    ]);
}
